var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtnCancelar)?_c('b-button',{staticClass:"ml-2",attrs:{"variant":"danger"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarCancelamento()}}},[_c('span',[_c('i',{staticClass:"fa fa-ban mr-2"}),_vm._v(" Cancelar Despesa ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }